module.exports = __webpack_public_path__ + "img/3.60a9a82e.png";